import {
    LOAD_RESTAURANT_SUCCESS,
    SAVE_RESTAURANT_SUCCESS,
    UPDATE_RESTAURANT_SUCCESS,
    CLEAR_RESTAURANT,
    SAVE_PAYMENT_SETTINGS_SUCCESS,
    GET_SERVICE_FEES_SUCCESS,
    GET_PAYMENT_PROVIDERS_SUCCESS,
    GET_SUBSCRIPTION_SUCCESS,
    LOAD_ADDITIONAL_CHARGES_SUCCESS,
    LOAD_COMPANY_INFO_SUCCESS,
    LOAD_BANK_ACCOUNT_SUCCESS,
    LOAD_INVOICES_SUCCESS,
    LOAD_ADDITIONAL_CHARGES_HISTORY_SUCCESS
} from '../../actions/types';

const INITIAL_STATE = {
    id: -1,
    currency: '',
    settings: "",
    autoSync: false,
    autoSyncHour: null,
    autoSyncMinute: null,
    paymentCode: null,
    serviceFees: [],
    paymentSettingsId: -1,
    providerType: null,
    paymentProviders: [],
    selectedPaymentType: "",
    type: {
        id: -1,
        value: "",
        template: "",
        supportChargeTypes: false,
        supportOrderTypes: true,
        supportTenderTypes: true
    },
    workingStatus: '',
    posStatus: '',
    chain: {
        id: -1,
        name: "",
        country: "",
        location: "",
        timeZone: "",
        locale: "",
        phone: "",
        email: "",
        manager: {},
        chain: {}
    },
    subscription: {},
    additionalCharges: {},
    companyInfo: {},
    bankAccount: {},
    invoices: {},
    inactive: false,
    additionalChargesHistory: {}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case LOAD_RESTAURANT_SUCCESS:
            return {
                ...state,
                address: action.payload.address,
                chain: action.payload.chain,
                currency: action.payload.currency,
                displayAddress: action.payload.displayAddress,
                email: action.payload.email,
                id: action.payload.id,
                locale: action.payload.locale,
                location: action.payload.location,
                manager: action.payload.manager,
                name: action.payload.name,
                offlineStatusCount: action.payload.offlineStatusCount,
                phone: action.payload.phone,
                posSettings: action.payload.posSettings,
                posStatus: action.payload.posStatus,
                posPaused: action.payload.posPaused,
                timeZone: action.payload.timeZone,
                workingStatus: action.payload.workingStatus,
                restaurantPriority: action.payload.restaurantPriority,
                inactive: action.payload.inactive
            };
        case SAVE_RESTAURANT_SUCCESS:
            return action.payload;
        case SAVE_PAYMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                paymentSettingsId: action.payload.id,
                providerType: action.payload.providerType,
                paymentCode: action.payload.paymentCode,
                settings: action.payload.settings,
                selectedPaymentType: action.payload.selectedPaymentType
            };
		case UPDATE_RESTAURANT_SUCCESS:
            return {
                ...state,
                address: action.payload.address,
                chain: action.payload.chain,
                currency: action.payload.currency,
                displayAddress: action.payload.displayAddress,
                email: action.payload.email,
                id: action.payload.id,
                locale: action.payload.locale,
                location: action.payload.location,
                manager: action.payload.manager,
                name: action.payload.name,
                offlineStatusCount: action.payload.offlineStatusCount,
                paymentCode: action.payload.paymentCode,
                serviceFees: action.payload.serviceFees,
                phone: action.payload.phone,
                posSettings: action.payload.posSettings,
                posStatus: action.payload.posStatus,
                posPaused: action.payload.posPaused,
                timeZone: action.payload.timeZone,
                inactive: action.payload.inactive
            };
        case GET_SERVICE_FEES_SUCCESS:
            return {
                ...state,
                serviceFees: action.payload
            };
        case GET_PAYMENT_PROVIDERS_SUCCESS:
            return {
                ...state,
                paymentProviders: action.payload
            };
        case CLEAR_RESTAURANT:
            return INITIAL_STATE;
        case GET_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscription: action.payload
            }
        case LOAD_ADDITIONAL_CHARGES_SUCCESS: 
            return {
                ...state,
                additionalCharges: action.payload
            }
        case LOAD_COMPANY_INFO_SUCCESS: 
            return {
                ...state,
                companyInfo: action.payload
            }
        case LOAD_BANK_ACCOUNT_SUCCESS:
            return {
                ...state,
                bankAccount: action.payload
            }
        case LOAD_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: action.payload
            }
        case LOAD_ADDITIONAL_CHARGES_HISTORY_SUCCESS:
            return {
                ...state,
                additionalChargesHistory: action.payload
            }
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/RestaurantReducer.js